import { AgentsRegionPageHeaderProps } from 'sly/agentsRegionPage/AgentsRegionPageContent/AgentsRegionPageData/AgentsRegionPageHeader/AgentsRegionPageHeader.types';
import Heading from 'sly/system/Heading';

export default function AgentsRegionPageHeader({
  title,
  titleRef,
  onClick,
}: AgentsRegionPageHeaderProps) {
  return (
    <div
      className='mx-auto mb-0 mt-16 w-[var(--col4)] text-center md:w-[var(--col6)]'
      ref={titleRef}
      data-tp-id='gen-div-f813ad7e-4815-4db4-bd60-69f872ab282e'
    >
      <Heading
        font='font-t-l'
        className='mb-8 text-center text-4xl leading-[1.33]'
        as='h1'
        data-tp-id='gen-Heading-3be696a7-5818-4840-b97e-a1796ece7046'
      >
        {title}
      </Heading>
      <span
        className='cursor-pointer underline'
        onClick={onClick}
        data-tp-id='gen-span-183946f2-893d-4f4e-823e-828ce816dd00'
      >
        Looking for agents in other areas?
      </span>
    </div>
  );
}
